import React, { PureComponent } from 'react'
import { Text, Box, Flex, Radio, RadioGroup, Stack } from '@chakra-ui/react'
import { getBodyContainer, handleKeyDown } from 'src/utils/helpers'
import SvgIcon from 'src/components/SvgIcon'
import { FormattedMessage } from 'react-intl'

// import Modal from 'src/components/Modal'
// import Button from 'src/components/Button'

import Button from 'src/components/Button/Button'

import styles from './styles.module.less'
import Modal from 'src/components/Modal/Modal'

class ChangeLanguage extends PureComponent {
  state = {
    currentLanguage: 'en',
  }

  componentDidMount() {
    const { language } = this.props

    this.setState({
      currentLanguage: language,
    })
  }

  changeLanguage = () => {
    const { setLanguage, onClose } = this.props

    const { language } = this.state

    if (language) {
      // Change language
      setLanguage(language)
    }

    onClose()
  }

  closeModal = () => {
    this.props.onClose()
  }

  handleChange = e => {
    this.setState({
      language: e,
    })
  }

  renderConfirmationContent = () => {
    const { currentLanguage } = this.state

    return (
      <div>
        <Flex direction={'column'}>
          <Box mb={'26px'}>
            <Text align={'left'} fontSize={'20px'} fontWeight={'bold'}>
              <FormattedMessage id='app.header.links.languageTitle' defaultMessage='Language' />
            </Text>
          </Box>
        </Flex>
        <Box>
          <RadioGroup
            isRequired
            defaultValue={currentLanguage}
            name='language'
            onChange={e => this.handleChange(e)}
          >
            <Stack direction='column'>
              <Radio for='language' value='en' variant='accent'>
                <Box ml={'20px'}>
                  <span
                    tabIndex='0'
                    onKeyDown={handleKeyDown(() => {
                      this.handleChange('en')
                    })}
                  >
                    English
                  </span>
                </Box>
              </Radio>
              <Radio for='language' value='fr' variant='accent' data-value='fr'>
                <Box ml={'20px'}>
                  <span
                    tabIndex='0'
                    onKeyDown={handleKeyDown(() => {
                      this.handleChange('fr')
                    })}
                  >
                    Français
                  </span>
                </Box>
              </Radio>
            </Stack>
          </RadioGroup>
        </Box>
        <Flex align={'center'} justify={'space-between'} mt={'24px'}>
          <Button isFullWidth onClick={this.changeLanguage}>
            <FormattedMessage id='app.global.done' defaultMessage='Done' />
          </Button>
        </Flex>
      </div>
    )
  }

  render() {
    const { isWidget, visible } = this.props

    // NOTE: we can't show modal in widget mode
    // so we are gonna render content as full screen page
    if (isWidget) {
      if (!visible) {
        return ''
      }
      return (
        <div>
          <div className={styles.widgetModalBackdrop} onClick={this.closeModal} />
          <div className={styles.widgetModal}>
            <span onClick={this.closeModal} className={styles.closeWidgetModalIconHolder}>
              <SvgIcon type='RemoveThinner' className={styles.closeWidgetModalIcon} />
            </span>
            <div className={styles.widgetModalContent}>{this.renderConfirmationContent()}</div>
          </div>
        </div>
      )
    }

    return (
      <Modal
        isOpen={visible}
        isCentered
        className={styles.pwaModal}
        closable={false}
        footer={null}
        onOk={this.submitModal}
        onClose={this.closeModal}
        renderContent={this.renderConfirmationContent}
        getContainer={() => getBodyContainer()}
      ></Modal>
    )
  }
}

export default ChangeLanguage
